



































import Vue from "@/shim-vue";
import { Component, Prop } from "vue-property-decorator";

import config from "@/config/loading";

@Component({
    name: "LoniLoading"
})
export default class LoniLoading extends Vue {
    /** 铺满父级容器（宽高布满整个最近的position:relative父级元素） */
    @Prop({ type: Boolean, default: undefined })
    public fix?: boolean;

    /** 图标尺寸（default-默认、large-大、small-小） */
    @Prop()
    public size?: "default" | "large" | "small";

    /** 图标颜色 */
    @Prop()
    public color?: string;

    /** 背景色 */
    @Prop()
    public background?: string;

    /** 内容居中 */
    @Prop({ type: Boolean, default: undefined })
    public center?: boolean;

    /** 加载状态图标类型（spin-菊花转转转、point-小点闪闪闪） */
    @Prop()
    public type?: "spin" | "point";

    /** transition过渡名称（用于自定义显示隐藏的过渡动画） */
    @Prop()
    public transition?: string;

    /** 不显示过渡动画 */
    @Prop({ type: Boolean, default: undefined })
    public disTransition?: boolean;

    /** 显示遮罩（全屏显示时有效） */
    @Prop({ type: Boolean, default: undefined })
    private cover?: boolean;

    /** 这个参数在正常使用是不需要用到的，这是使用全屏弹窗加载状态时使用的私有参数 */
    @Prop({ type: Boolean, default: false })
    private fullScreen!: boolean;

    public get options() {
        return {
            size: this.size ?? config.size,
            color: this.color ?? config.color,
            background: this.background ?? config.background,
            type: this.type ?? config.type,
            center: this.center ?? config.center,
            fix: this.fix ?? config.fix,
            transition: this.transition ?? config.transition,
            disTransition: this.disTransition ?? config.disTransition,
            cover: this.cover ?? config.cover
        }
    }

    public visible = false;

    private get modeVisible() {
        return this.fullScreen ? this.visible : true;
    }
}
